import Products from "../../Components/Products/inedx"

function Category() {
    return <div>
        <Products/>
    </div>
}

export default Category